import React, { useEffect, useState } from 'react';
import Modal from './ui/Modal';
import Btn from './ui/Btn';
import { Input } from './ui/Input';
import { produtosApi } from '../api/produtos';
import { COLORS } from '../theme';

const LIMITE = 20;

export default function ProdutoSearchModal({ onSelecionar, onFechar }) {
  const [busca, setBusca] = useState('');
  const [pagina, setPagina] = useState(1);
  const [produtos, setProdutos] = useState([]);
  const [temMais, setTemMais] = useState(false);
  const [carregando, setCarregando] = useState(false);

  const buscar = (paginaAlvo, buscaAlvo, acumular) => {
    setCarregando(true);
    produtosApi.listar({ busca: buscaAlvo, pagina: paginaAlvo, limite: LIMITE, suspenso: 'false' })
      .then(lista => {
        setProdutos(prev => acumular ? [...prev, ...lista] : lista);
        setTemMais(lista.length === LIMITE);
      })
      .catch(() => {})
      .finally(() => setCarregando(false));
  };

  useEffect(() => {
    const t = setTimeout(() => { setPagina(1); buscar(1, busca, false); }, 300);
    return () => clearTimeout(t);
  }, [busca]); // eslint-disable-line

  const verMais = () => {
    const proxima = pagina + 1;
    setPagina(proxima);
    buscar(proxima, busca, true);
  };

  return (
    <Modal titulo="Buscar Produto no Catálogo" onFechar={onFechar} largura={640}>
      <Input
        placeholder="Buscar por código, nome, descrição ou código do fabricante..."
        value={busca}
        onChange={e => setBusca(e.target.value)}
        autoFocus
        style={{ marginBottom: 14 }}
      />

      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 420, overflowY: 'auto' }}>
        {produtos.map(p => (
          <div
            key={p.id}
            onClick={() => onSelecionar(p)}
            style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '10px 12px', border: `1px solid ${COLORS.border}`, borderRadius: 8, cursor: 'pointer'
            }}
            onMouseEnter={e => { e.currentTarget.style.background = COLORS.bg; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
          >
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: COLORS.text }}>{p.codigo} — {p.nome}</div>
              <div style={{ fontSize: 12, color: COLORS.textMid }}>
                {p.codigo_fabricante ? `Cód. Fabricante: ${p.codigo_fabricante}` : 'Sem código de fabricante'}
              </div>
            </div>
          </div>
        ))}
        {!carregando && produtos.length === 0 && (
          <p style={{ fontSize: 13, color: COLORS.textMid, textAlign: 'center', padding: 20 }}>Nenhum produto encontrado.</p>
        )}
        {carregando && produtos.length === 0 && (
          <p style={{ fontSize: 13, color: COLORS.textMid, textAlign: 'center', padding: 20 }}>Buscando...</p>
        )}
      </div>

      {temMais && (
        <div style={{ textAlign: 'center', marginTop: 12 }}>
          <Btn variante="ghost" onClick={verMais} disabled={carregando}>{carregando ? 'Carregando...' : 'Ver mais'}</Btn>
        </div>
      )}
    </Modal>
  );
}
